import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ProjectIcon from '../../../../assests/dashboard/homepage/quickApproach/project-icon.png'
import LessonIcon from '../../../../assests/dashboard/homepage/quickApproach/lesson-icon.png'
import { projectsApi, lessonsApi } from '../../../../utils'
import Moment from 'moment';
import * as PathRouter from '../../../../models/PathRoute'
import classes from "./QuickApproach.module.css";
import { throwApiError } from "../../../lms-shared/store/error-handling-actions";
import { onKeyDown } from "../../../../service";
import { ObjectTypeEnumText } from "../../../../models/ObjectTypeEnum";

const QuickApproach = ({ setShowQuickApproachPopup, showQuickApproachPopup, setShowMessagesPopup, studyGroupId }) => {
    const navigate = useNavigate();
    const { direction, texts } = useSelector((state) => state.translate);
    const homeUrl = useSelector(state => state.application.homeUrl);
    const dispatch = useDispatch()

    const [projectsData, setProjectsData] = useState([])
    const [lessonsData, setLessonsData] = useState([])

    useEffect(() => {
        async function getProjectsData() {
            const data = {
                refObjectId: studyGroupId,
                limitCount: 1,
                refObjectType: ObjectTypeEnumText.StudyGroup
            }
            projectsApi.projectsFilterLastChangedRangePost({ projectsLastChangedRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "projectsFilterLastChangedRangePost " + error.message, level: 1, component: "QuickApproach", line: 30 }))
                } else {
                    setProjectsData(resdata)
                }
            })
        }
        getProjectsData()

        async function getLessonsData() {
            const data = {
                studyGroupId: studyGroupId,
                limitCount: 1
            }
            lessonsApi.lessonsFilterLastChangedRangePost({ lessonsLastChangedRangeFilter: data }, (error, resdata, response) => {
                if (error) {
                    dispatch(throwApiError({ userMessage: "", error: error, statusCode: response?.statusCode, message: "lessonsFilterLastChangedRangePost " + error.message, level: 1, component: "QuickApproach", line: 45 }))
                } else {
                    setLessonsData(resdata)
                }
            })
        }
        // no API
        getLessonsData()
    }, [])

    function ShowQuickApproachPopup(e) {
        e.stopPropagation();
        setShowMessagesPopup(false)
        setShowQuickApproachPopup((showQuickApproachPopup) => !showQuickApproachPopup)
    }

    return (
        <>
            {!showQuickApproachPopup && <div className={`${classes[direction]} ${classes.QuickApproachTab}`} onClick={(e) => ShowQuickApproachPopup(e)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => ShowQuickApproachPopup(e))}>
                <div className={classes.TabText} >{texts.recentProjects}</div>
                <div className={classes.PopupIcon}></div>
            </div>}
            <div className={`${direction === 'ltr' ? classes.ltrQuickApproachContainer : ''} ${classes.QuickApproachContainer} ${showQuickApproachPopup ? classes.OpenQuickApproachPopup : classes.CloseQuickApproachPopup}`}>
                <div className={classes.QuickApproach}>
                    <div className={classes.PopupName}>
                        <div className={classes.TabText} >{texts.recentProjects}</div>
                        <div className={classes.PopupIcon}></div>
                    </div>
                    <div className={`${classes.Column} ${classes.LastProjects}`}>
                        <div className={`${classes.Title} ${classes.LastProjectsText}`}>{texts.lastProjects}</div>
                        {projectsData && projectsData.length > 0 ? 
                        <>
                            {projectsData.map((p, i) => <React.Fragment key={p.id}>
                            {p && p.name && <div className={`${classes.Row} ${classes.Project}`} onClick={() => navigate(`${homeUrl}/${studyGroupId}/project/${p.id}`, { state: { prevPath: window.location.pathname, replace: true } })} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}/${studyGroupId}/project/${p.id}`, { state: { prevPath: window.location.pathname, replace: true } }))}>
                                <img src={ProjectIcon} alt="projectIcon" />
                                <div className={classes.Description}>
                                    <div className={classes.Name}>{p.name}</div>
                                    <div className={classes.Date}>{Moment(p.lastChanged).format('DD/MM/YYYY')}</div>
                                </div>
                            </div>}
                            </React.Fragment>)}
                        </>
                        :
                        <div className={classes.Explanation}>{texts.hereCanFind}{texts.projects} {texts.youMadeLast}</div>
                        }
                        <div className={classes.Name} onClick={() => navigate(`${homeUrl}/${studyGroupId}/${PathRouter.PROJECTS}`)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}/${studyGroupId}/${PathRouter.PROJECTS}`))}>{`${texts.moreProjects} >>`}</div>
                    </div>
                    <div className={classes.Line}></div>
                    <div className={`${classes.Column} ${classes.LastLessons}`}>
                        <div className={`${classes.Title} ${classes.LastLessonsText}`}>{texts.lastLessons}</div>
                        {lessonsData && lessonsData.length > 0 ? 
                        <>
                            {lessonsData.map((l, i) => <React.Fragment key={l.id}>
                            {l && l.name && <div className={`${classes.Row} ${classes.Lesson}`} onClick={() => navigate(`${homeUrl}/${studyGroupId}/lesson/${l.id}`)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}/${studyGroupId}}/lesson/${l.id}`))}>
                                <img src={LessonIcon} alt="lessonIcon" />
                                <div className={classes.Description}>
                                    <div className={classes.Name}>{l.name}</div>
                                    <div className={classes.Date}>{Moment(l.lastChanged).format('DD/MM/YYYY')}</div>
                                </div>
                            </div>}
                            </React.Fragment>)}
                        </> 
                        :
                        <div className={classes.Explanation}>{texts.hereCanFind}{texts.lessons} {texts.youMadeLast}</div>
                        }
                        <div className={classes.Name} onClick={() => navigate(`${homeUrl}/${studyGroupId}/${PathRouter.ASSESSMENTS}`)} tabIndex="0" role="button" onKeyDown={e => onKeyDown(e, () => navigate(`${homeUrl}/${studyGroupId}/${PathRouter.ASSESSMENTS}`))}>{`${texts.moreLessons} >>`}</div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default QuickApproach;